import { createFileRoute } from '@tanstack/react-router';
import { SettingsWhatsAppTab } from '../../../features/B2a/settings-whatsapp';

/** Settings › "וואטסאפ וקצב": OpenWA connection summary + sending pace. Lane B2a (the settings layout is lane B1's). */
export const Route = createFileRoute('/_app/settings/whatsapp')({
  component: SettingsWhatsAppTab,
});
